import { Box, Divider, IconButton, Typography } from "@material-ui/core";
import React from "react";
import useStyles from "../../styles/components/Footer";
import { WhatsApp, Instagram, MailOutline } from "@material-ui/icons";
import { TFunction } from "next-i18next";
import { Router } from "../../i18n";

type FooterProps = {
  readonly t: TFunction;
};

const Footer = (props: FooterProps) => {
  const { t } = props;
  const classes = useStyles();

  return (
    <Box className={classes.footerWrapper}>
      <Box className={classes.footerContent}>
        <Box className={classes.footerTopContent}>
          <Box>
            <Typography variant="body1" className={classes.titleContent}>
              Pesan Trip
            </Typography>
            <Typography className={classes.hotelAddress}>
              Semarang, Indonesia
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" className={classes.titleContent}>
              {t("pages")}
            </Typography>
            <ul className={classes.footerPageList}>
              {/* <li className={classes.footerPage}>{t("food/drink")}</li>
              <li className={classes.footerPage}>{t("souvenir")}</li> */}
              <li
                className={classes.footerPage}
                onClick={() => {
                  window.open(
                    `https://wa.me/${
                      process.env.WHATSAPP_DEFAULT || "6288802870057"
                    }`,
                    "_blank"
                  );
                }}
              >
                {t("contact")}
              </li>
              <li
                className={classes.footerPage}
                onClick={() => Router.push("/privacy-policy")}
              >
                {t("privacy-policy")}
              </li>
            </ul>
          </Box>
          <Box>
            <Typography variant="body1" className={classes.titleContent}>
              {t("contact-us")}
            </Typography>
            <Box className={classes.socialMediaWrapper}>
              <IconButton
                className={classes.socialMediaButton}
                onClick={() => {
                  window.open(
                    `https://wa.me/${
                      process.env.WHATSAPP_DEFAULT || "6288802870057"
                    }`,
                    "_blank"
                  );
                }}
              >
                <WhatsApp />
              </IconButton>
              <IconButton
                className={classes.socialMediaButton}
                onClick={() =>
                  window.open(
                    `https://www.instagram.com/${
                      process.env.INSTAGRAM || "pesan_io"
                    }/`,
                    "_blank"
                  )
                }
              >
                <Instagram />
              </IconButton>
              <IconButton
                className={classes.socialMediaButton}
                onClick={() => {
                  window.open(
                    `mailto:${process.env.EMAIL || "r@jawara.io"}`,
                    "_blank"
                  );
                }}
              >
                <MailOutline />
              </IconButton>
            </Box>
          </Box>
        </Box>
        <Divider className={classes.divider} />
        <Typography className={classes.copywriting}>
          &copy; 2024 Pesan.io - All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
